"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var recompose_1 = require("recompose");
var react_input_mask_1 = __importDefault(require("react-input-mask"));
var format_1 = __importDefault(require("date-fns/format"));
var lodash_1 = require("lodash");
var muiThemeable_1 = __importDefault(require("material-ui/styles/muiThemeable"));
var date_range_1 = __importDefault(require("material-ui/svg-icons/action/date-range"));
var DateTimeDialog_1 = __importDefault(require("./DateTimeDialog"));
var Input_1 = __importDefault(require("../Input"));
var IconButton_1 = __importDefault(require("../IconButton"));
var reduxFormWrappers_1 = require("../reduxFormWrappers");
var utils_1 = require("../../../utils");
var toISO = function (value) {
    return value && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(value)
        ? value + ":00.000Z"
        : value && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(value)
            ? value + ".000Z"
            : value && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}$/.test(value)
                ? value + "Z"
                : value;
};
var DateTime = function (_a) {
    var booleanTranslation = _a.booleanTranslation, // eslint-disable-line
    value = _a.value, okLabel = _a.okLabel, cancelLabel = _a.cancelLabel, handleChange = _a.handleChange, handleText = _a.handleText, handleDialog = _a.handleDialog, dateOnly = _a.dateOnly, iconStyle = _a.iconStyle, state = _a.state, muiTheme = _a.muiTheme, dispatch = _a.dispatch, locale = _a.locale, minutesStep = _a.minutesStep, className = _a.className, showToday = _a.showToday, todayLabel = _a.todayLabel, commitOnToday = _a.commitOnToday, wrapperStyle = _a.wrapperStyle, mask = _a.mask, placeholder = _a.placeholder, suffix = _a.suffix, minDate = _a.minDate, maxDate = _a.maxDate, readOnly = _a.readOnly, compact = _a.compact, withoutZone = _a.withoutZone, id = _a.id, onDialogClose = _a.onDialogClose, dateTimeInISO = _a.dateTimeInISO, rest = __rest(_a, ["booleanTranslation", "value", "okLabel", "cancelLabel", "handleChange", "handleText", "handleDialog", "dateOnly", "iconStyle", "state", "muiTheme", "dispatch", "locale", "minutesStep", "className", "showToday", "todayLabel", "commitOnToday", "wrapperStyle", "mask", "placeholder", "suffix", "minDate", "maxDate", "readOnly", "compact", "withoutZone", "id", "onDialogClose", "dateTimeInISO"]);
    var dialogHandler = function () {
        handleDialog();
        if (onDialogClose) {
            onDialogClose();
        }
    };
    var inputPlaceHolder = placeholder === undefined ? (dateOnly ? 'dd.mm.yyyy' : 'dd.mm.yyyy --:--') : placeholder;
    var inputMask = mask === undefined ? (dateOnly ? '99.99.9999' : '99.99.9999 99:99') : mask;
    var initialDate = lodash_1.isEmpty(value)
        ? new Date()
        : !dateOnly && withoutZone
            ? utils_1.isoStringToDateWithoutZone(value)
            : new Date(!dateOnly && dateTimeInISO ? toISO(value) : value);
    var wrapperStyleDefault = {
        width: 256,
        display: 'flex',
        alignItems: 'center',
    };
    var inputStyle = { flex: 1, width: 'auto' };
    return (react_1.default.createElement("div", { className: className, style: __assign({}, wrapperStyleDefault, wrapperStyle) },
        state.dialog && (react_1.default.createElement(DateTimeDialog_1.default, { minutesStep: minutesStep, handleDialog: dialogHandler, onChange: handleChange, theme: muiTheme.dateTimePicker, dateOnly: dateOnly, locale: locale, dispatch: dispatch, initialDate: initialDate, okLabel: okLabel, cancelLabel: cancelLabel, todayLabel: todayLabel, showToday: showToday, commitOnToday: commitOnToday, suffix: suffix, minDate: minDate, maxDate: maxDate, dateTimeInISO: dateTimeInISO })),
        readOnly && !compact && (react_1.default.createElement(Input_1.default, __assign({}, rest, { onChange: handleText, value: state.text, placeholder: inputPlaceHolder, readOnly: true, style: __assign({}, inputStyle, lodash_1.get(rest, 'style', [])) }))),
        !readOnly && !compact && (react_1.default.createElement(Input_1.default, __assign({}, rest, { onChange: handleText, value: state.text, style: __assign({}, inputStyle, lodash_1.get(rest, 'style', [])), id: id ? id + "-input" : undefined }),
            react_1.default.createElement(react_input_mask_1.default, { mask: inputMask, placeholder: inputPlaceHolder, value: state.text }))),
        !compact && react_1.default.createElement(date_range_1.default, { style: iconStyle, color: muiTheme.dateTimePicker.icon.color, onClick: handleDialog }),
        compact && (react_1.default.createElement(IconButton_1.default, { onClick: handleDialog, tooltip: state.text ? state.text : 'Kliknutím vyberte datum', tooltipPosition: "top-center", touch: true },
            react_1.default.createElement(date_range_1.default, { style: iconStyle, color: muiTheme.dateTimePicker.icon.color, onClick: handleDialog })))));
};
exports.dateTimeReducer = function (state, action) {
    switch (action.type) {
        case 'DIALOG':
            return __assign({}, state, { dialog: action.payload });
        case 'TEXT':
            return __assign({}, state, { text: action.payload });
        default:
            return state;
    }
};
exports.formatDateOnly = function (stringDate, dateTimeInISO) {
    if (lodash_1.isEmpty(stringDate))
        return '';
    var d = new Date(dateTimeInISO ? toISO(stringDate) : stringDate);
    var month = lodash_1.padStart(d.getMonth() + 1, 2, '0');
    var day = lodash_1.padStart(d.getDate(), 2, '0');
    return day + "." + month + "." + d.getFullYear();
};
exports.formatDate = function (stringDate, dateTimeInISO, withoutZone) {
    if (withoutZone === void 0) { withoutZone = false; }
    if (lodash_1.isEmpty(stringDate))
        return '';
    if (withoutZone)
        return utils_1.formatDateWithoutZone(stringDate);
    var d = new Date(dateTimeInISO ? toISO(stringDate) : stringDate);
    var hours = lodash_1.padStart(d.getHours(), 2, '0');
    var minutes = lodash_1.padStart(d.getMinutes(), 2, '0');
    return exports.formatDateOnly(stringDate, dateTimeInISO) + " " + hours + ":" + minutes;
};
var intialState = function (_a) {
    var dateOnly = _a.dateOnly, dateTimeInISO = _a.dateTimeInISO, withoutZone = _a.withoutZone, value = _a.value;
    return ({
        dialog: false,
        text: dateOnly ? exports.formatDateOnly(value) : exports.formatDate(value, dateTimeInISO, withoutZone),
    });
};
var ComposedDateTime = recompose_1.compose(recompose_1.defaultProps({
    minutesStep: 5,
    todayLabel: 'Dnes',
    dateOnly: false,
    withoutZone: false,
    showToday: true,
    commitOnToday: false,
    dateTimeInISO: false,
    suffix: '',
    locale: 'cs-CZ',
    okLabel: 'OK',
    cancelLabel: 'Zrušit',
    wrapperStyle: {},
    onInputChange: function () { },
}), recompose_1.mapProps(function (props) {
    return props.locale === 'en-US'
        ? __assign({}, props, { cancelLabel: 'Cancel', todayLabel: 'Today' }) : props;
}), muiThemeable_1.default(), recompose_1.withReducer('state', 'dispatch', exports.dateTimeReducer, intialState), recompose_1.withHandlers({
    handleDialog: function (_a) {
        var dispatch = _a.dispatch, disabled = _a.disabled, readOnly = _a.readOnly, state = _a.state;
        return function () {
            if (!disabled && !readOnly) {
                dispatch(utils_1.createAction('DIALOG', !state.dialog));
            }
        };
    },
    handleText: function (_a) {
        var dateOnly = _a.dateOnly, onChange = _a.onChange, onInputChange = _a.onInputChange, dispatch = _a.dispatch, suffix = _a.suffix, dateTimeInISO = _a.dateTimeInISO;
        return function (_value) {
            var pattern = dateOnly ? /(\d{1,2})\.(\d{1,2})\.(\d{4})/ : /(\d{1,2})\.(\d{1,2})\.(\d{4})\s?(\d{1,2}:\d{1,2})?/;
            // remove placeholder from the value
            var value = _value.replace(/_\./g, '').replace(/_/g, '');
            onInputChange(value);
            if (pattern.test(value)) {
                var date = dateOnly ? value.replace(pattern, '$3-$2-$1') : value.replace(pattern, '$3-$2-$1T$4');
                var formatted = dateOnly
                    ? format_1.default(date, 'YYYY-MM-DD') + suffix
                    : dateTimeInISO
                        ? format_1.default(date, 'YYYY-MM-DDTHH:mm') !== 'Invalid Date'
                            ? new Date(format_1.default(date, 'YYYY-MM-DDTHH:mm')).toISOString().substr(0, 16)
                            : 'Invalid Date'
                        : format_1.default(date, 'YYYY-MM-DDTHH:mm') + suffix;
                if (formatted !== 'Invalid Date')
                    onChange(formatted, 'TEXT');
            }
            else if (value === '' || value === null || (!dateOnly && value && value.replace(/\s*:\s*/, '') === '')) {
                onChange(null, 'TEXT');
            }
            dispatch(utils_1.createAction('TEXT', value));
        };
    },
    handleChange: function (props) { return function (value) {
        props.onChange(value, 'DIALOG');
    }; },
}), recompose_1.lifecycle({
    componentWillReceiveProps: function (_a) {
        var newValue = _a.value, dispatch = _a.dispatch, dateOnly = _a.dateOnly, dateTimeInISO = _a.dateTimeInISO;
        var value = this.props.value;
        if (value !== newValue) {
            // update visible state according to set value
            dispatch(utils_1.createAction('TEXT', dateOnly ? exports.formatDateOnly(newValue) : exports.formatDate(newValue, dateTimeInISO)));
        }
    },
}))(DateTime);
exports.default = ComposedDateTime;
exports.FormDateTime = reduxFormWrappers_1.formWrapper(ComposedDateTime);
//# sourceMappingURL=DateTime.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/DateTime/DateTime.js
// module id = 270
// module chunks = 0